import React, { Component } from 'react'

import PropTypes from 'prop-types'
import Avatar from 'react-avatar-edit'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as currentUserDuck from '../../../../store/shared/currentUserDuck'
import applicationConstants from '../../../../utils/constants/application'
import notificationsUtils from '../../../../utils/notifications/notificationsUtils'
import { getProfilePictureUrl } from '../../../../utils/pictureUrlCreator'
import { getNestedProp } from '../../../../utils/ramda'
import * as userProfileDuck from '../userProfileDuck'

const imageStyle = {
  width: 200,
  height: 200,
  borderRadius: 125,
  borderWidth: 3,
  borderColor: 'white',
  marginTop: 10,
  marginBottom: 10,
}

export class UserProfileImage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      croppedImage: null,
      showingImageEditor: false,
    }

    this.toggleShowingImageEditor = nextState => this.setState({ showingImageEditor: nextState })

    this.storeCroppedImage = (image = '') => {
      this.setState({ croppedImage: image.length ? image : null })
    }

    this.renderImageEditor = () => {
      return (
        <div>
          <Avatar
            width={250}
            height={250}
            lineWidth={8}
            imageWidth={80}
            minCropRadius={50}
            backgroundColor="black"
            shadingOpacity={0.9}
            onCrop={this.storeCroppedImage}
            onClose={() => this.toggleShowingImageEditor(false)}
          />
          <button
            disabled={!this.state.croppedImage}
            className="btn btn-success btn-block"
            onClick={() => this.uploadAndSaveImage(this.state.croppedImage)}
          >
            Save Picture
          </button>
          <button className="btn btn-link" onClick={() => this.toggleShowingImageEditor(false)}>
            Cancel
          </button>
        </div>
      )
    }

    this.renderAvatar = () => {
      const {
        currentUser: { user },
      } = this.props
      return (
        <div>
          <img
            src={
              getNestedProp('profile.picture', user)
                ? getProfilePictureUrl(user.profile.picture)
                : applicationConstants.default_profile_picture_url
            }
            alt={`${getNestedProp('profile.name', user)} - Steppingblocks`}
            className="img img-fluid"
            style={imageStyle}
          />
          <button className="btn btn-link" onClick={() => this.toggleShowingImageEditor(true)}>
            Change Picture
          </button>
        </div>
      )
    }

    this.uploadAndSaveImage = async image => {
      try {
        const { user } = await this.props.performUpdateProfilePicture({
          profile_picture_data: image,
        })
        this.props.currentUserSuccess(user)
        this.toggleShowingImageEditor(false)
        notificationsUtils.showSuccessNotification('Profile picture updated!')
      } catch (error) {
        notificationsUtils.showErrorNotification(error.message)
      }
    }
  }

  render() {
    const { showingImageEditor } = this.state

    return showingImageEditor ? this.renderImageEditor() : this.renderAvatar()
  }
}

UserProfileImage.propTypes = {
  currentUser: currentUserDuck.currentUserPropTypes,
  currentUserSuccess: PropTypes.func.isRequired,
  performUpdateUserProfile: PropTypes.func.isRequired,
  userProfile: userProfileDuck.userProfilePropTypes,
  performUpdateProfilePicture: PropTypes.func.isRequired,
}

const mapStateToProps = _state => ({
  currentUser: _state.currentUser,
  userProfile: _state.userProfile,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      currentUserSuccess: currentUserDuck.currentUserSuccess,
      performUpdateUserProfile: userProfileDuck.performUpdateUserProfile,
      performUpdateProfilePicture: userProfileDuck.performUpdateProfilePicture,
    },
    dispatch,
  )

export default connect(mapStateToProps, mapDispatchToProps)(UserProfileImage)



// WEBPACK FOOTER //
// ./src/routes/authenticated/UserProfile/components/UserProfileImage.js